export default __webpack_public_path__ + "static/media/plan-salon2.4570b0e3.png";